CheckoutV2.Cart.Promotions = function(checkout, cart) {
    var promos = this;
    
    // UI elements
    this.$notifications = $('.promo-notifications');
    this.$promoCode     = $('.js-promotions .js-code');
    this.$applyBtn      = $('.js-promotions .js-code-apply');
    this.$removeBtn     = $('.js-promotions .js-code-remove');
    this.$codeResult    = $('.js-promotions .js-code-result');

    this.effectActions = {
        acceptCode: {
            template: '<b>$promo-code</b> has been applied successfully!<br>$message',
            class   : 'success'
        },
        validCode: {
            template: '<b>$promo-code</b> is valid!<br>No discount was applied',
            class   : 'success'
        },
        rejectCode: {
            template: '<b>$promo-code</b> could not be applied!<br>$message',
            class   : 'fail'
        },
        removeCode: {
            template: '<b>$promo-code</b> has been removed!',
            class   : 'success'
        },
        showNotification: {
            template: '<div class="notification $level"><i class="fa $badge"></i>$message</div>',
            badges  : {
                'info'  : 'fa-info-circle',
                'offer' : 'fa-info-circle',
                'error' : 'fa-exclamation-circle',
                'misc'  : 'fa-info-circle'
            },
            levels  : {
                'Info'  : 'info',
                'Misc'  : 'misc',
                'Error' : 'error',
                'Offer' : 'offer'
            }
        }
    };

    this.init = function() {
        promos.listen();
    };
    
    this.listen = function() {
        promos.$applyBtn.on('click', function(e) {
            promos.applyCode();
        });
        
        promos.$removeBtn.on('click', function(e) {
            promos.removeCode();
        });
    };
    
    this.clearNotifications = function() {
        promos.$notifications.html('');
    };
    
    this.clearCodeResult = function() {
        promos.$codeResult.hide();
        promos.$codeResult.html('');
        promos.$codeResult.removeClass('success');
        promos.$codeResult.removeClass('fail');
    };

    this.applyCode = function() {
        this.clearCodeResult();
        this.clearNotifications();
        
        var code = promos.$promoCode.val().toUpperCase().trim();
        if (!code) return;
        
        checkout.remote.call({
            'data': {
               'step': 'cart',
               'action': 'applyCode',
               'promotionCode': code,
               //'profileId': checkout.session.isLoggedIn() ? checkout.session.get('billing.email') : '',
            }
        })
    	  .done(function(response) {
            var codeApplied = false;
            var codeEffect;
            var discountApplied = false;
            var refreshCart = false;
            if (response.warning) {
                promos.showNotification({
                  type: 'Error',
                  message: 'An error occurred while validating the promotion!'
                });
            } else {
                $.each(response.data, function(i, effect) {
                    if (effect.action === 'showNotification' && effect.message) {
                        promos.showNotification(effect);
                    } else if (effect.action === 'acceptCode') {
                        codeApplied = true;
                        codeEffect = effect;
                    } else if (effect.action === 'rejectCode') {
                        if (!codeApplied) codeEffect = effect;
                    } else if (effect.action === 'setDiscount' || effect.action === 'setDiscountPerItem') {
                      discountApplied = true;
                      refreshCart = true;
                    }
                });
            }
            if (codeEffect && codeEffect.action == 'acceptCode' && !discountApplied) {
                codeEffect.action = 'validCode';
            }
            if (codeEffect) {
                promos.showCodeResult(codeEffect);
            }
            if (codeApplied && discountApplied) {
                promos.setRemove(codeEffect.code);
            } else {
                promos.setApply();
            }
            if (refreshCart) {
              checkout.cart.checkItems(true, false, cart.usePoETA);
            }
        })
        .fail(function(request) {
            var errorMsg = checkout.remote.getErrorMsg(request);
            if (errorMsg) {
                console.log('applyCode error: ' + errorMsg);
            }
        });
    };
    
    this.applyCodeManual = function(code) {
        if (!promos.$promoCode.val() && code) {
            promos.showCodeResult({
                action: 'acceptCode',
                code: code,
                message: ''
            });
            promos.setRemove(code);
        }
    };
    
    this.validateCode = function(response) {
        this.clearCodeResult();
        this.clearNotifications();
        
        var code = response.promtionCode || (promos.$promoCode.val() || '').toUpperCase().trim();
        if (!code) return;
        
        var codeApplied = false;
        var codeEffect;
        var discountApplied = false;
        var refreshCart = false;
        if (response.info || response.warning) {
            promos.showNotification({
              type: 'Error',
              message: 'An error occurred while validating the promotion!'
            });
        } else {
            $.each((response.results || response.data), function(i, effect) {
                if (effect.action === 'showNotification' && effect.message) {
                    promos.showNotification(effect);
                } else if (effect.action === 'acceptCode') {
                    codeApplied = true;
                    codeEffect = effect;
                } else if (effect.action === 'rejectCode') {
                    if (!codeApplied) codeEffect = effect;
                } else if (effect.action === 'setDiscount' || effect.action === 'setDiscountPerItem') {
                  discountApplied = true;
                  if (response.refreshCart !== false)
                      refreshCart = true;
                }
            });
        }
        if (codeEffect && codeEffect.action == 'acceptCode' && !discountApplied) {
            codeEffect.action = 'validCode';
        }
        if (codeEffect) {
            promos.showCodeResult(codeEffect);
        }
        if (codeApplied && discountApplied) {
            promos.setRemove(codeEffect.code);
        } else {
            promos.setApply();
        }
        if (refreshCart) {
          checkout.cart.checkItems(true, false, cart.usePoETA);
        }
        
    };
    
    this.removeCode = function() {
        promos.clearCodeResult();
        promos.clearNotifications();

        var code = promos.$promoCode.val().toUpperCase().trim();

        checkout.remote.call({
            'data': {
               'step': 'cart',
               'action': 'removeCode',
               //'profileId': checkout.session.isLoggedIn() ? checkout.session.get('billing.email') : '',
            }
        })
    	  .done(function(response) {
            promos.setApply();
            promos.showCodeResult({
                action  : 'removeCode',
                code    : code
            });
            checkout.cart.checkItems(true, false, cart.usePoETA, undefined, {promoCodeRemoved: 1});
        })
        .fail(function(request) {
            var errorMsg = checkout.remote.getErrorMsg(request);
            if (errorMsg) {
                console.log('removeCode error: ' + errorMsg);
            }
        });
    };
    
    this.setRemove = function(code) {
        promos.$applyBtn.hide();
        promos.$removeBtn.show();
        promos.$promoCode.val(code);
        promos.$promoCode.attr('readonly', true);
    };
    
    this.setApply = function() {
        promos.$removeBtn.hide();
        promos.$applyBtn.show();
        promos.$promoCode.val('');
        promos.$promoCode.attr('readonly', false);
    };
    
    this.validateCart = function() {
        var code = promos.getAppliedCode();
        if (!code) return;
        
        checkout.remote.call({
            'data': {
               'step': 'cart',
               'action': 'validateCartCode',
               'promotionCode': code,
            }
        })
        .done(function(response) {
            if (response.data.valid === 0) {
                checkout.cart.checkItems(true, true, cart.usePoETA);
            }
        })
        .fail(function(request) {
            var errorMsg = checkout.remote.getErrorMsg(request);
            if (errorMsg) {
                console.log('validateCart error: ' + errorMsg);
            }
        });
    };
    
    this.validateCartLogin = function(options) { // need to combine checkItems and validateCart
        options.isV2Checkout = checkout.config.isV2Checkout;
        options.usePoETA = cart.usePoETA;

        var code = promos.getAppliedCode();
        options.promotionCode = code;
        
        checkout.remote.call({
            'data': {
               'step': 'cart',
               'action': 'validateCartCodeLogin',
               'options': encodeURIComponent(JSON.stringify(options)),
            }
        })
        .done(function(response) {
            if (response.data.valid === 0 || response.data.refreshCart === 1) {
                checkout.cart.checkItems(true, true, cart.usePoETA);
            } else {
              checkout.cart.checkItems();
            }
            checkout.login.setEstimatedShippingFields();
            checkout.login.loadAddresses();
            checkout.login.proceed();
        })
        .fail(function(request) {
            var errorMsg = checkout.remote.getErrorMsg(request);
            if (errorMsg) {
                console.log('validateCart error: ' + errorMsg);
            } else {
                console.log('validateCart error');   
            }
        });
    };
    
    this.showNotification = function(effect) {
        var effectAction = promos.effectActions['showNotification'];
        var level = effectAction.levels[effect.type];
        var badge = effectAction.badges[level];
        var message = effect.message;
        var notification = effectAction.template
                                .replace('$level', level)
                                .replace('$badge', badge)
                                .replace('$message', message);
        promos.$notifications.append(notification);
    };
    
    this.showCodeResult = function(effect) {
        promos.clearCodeResult();
        var effectAction = promos.effectActions[effect.action];
        var codeResult = effectAction.template
                            .replace('$promo-code', effect.code)
                            .replace('$message', effect.message);
        promos.$codeResult.html(codeResult);
        promos.$codeResult.addClass(effectAction.class);
        promos.$codeResult.show();
    };
    
    this.getAppliedCode = function() {
        return promos.$promoCode.attr('readonly') ? promos.$promoCode.val() : '';
    };
    
    this.init();
};
